import { CashInCashOutMethod } from '@nemuru-eng/js-api-client';

import { SpanishBanks } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantCashInCashOutMethod/constants/SpanishBanks';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

interface MerchantCashInCashOutMethodFormProps extends FormGridOptions {
  cashInCashOutMethod?: CashInCashOutMethod;
}

export function MerchantCashInCashOutMethodForm({
  cashInCashOutMethod,
  fullWidth,
  fieldVariant,
}: MerchantCashInCashOutMethodFormProps) {
  const lastName = cashInCashOutMethod?.accountHolderFirstLastName
    ? `${cashInCashOutMethod?.accountHolderFirstLastName} ${cashInCashOutMethod?.accountHolderSecondLastName}`
    : undefined;

  return (
    <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
      <TextFormField
        label={'ACCOUNT_HOLDER_FIRSTNAME'}
        value={cashInCashOutMethod?.accountHolderFirstName}
        name={'accountHolderFirstName'}
      />
      <TextFormField label={'ACCOUNT_HOLDER_LASTNAME'} value={lastName} name={'accountHolderLastName'} />

      <TextFormField
        label={fieldVariant === FieldVariant.form ? 'ACCOUNT_NUMBER' : 'IBAN'}
        value={cashInCashOutMethod?.accountNumber}
        name={'accountNumber'}
      />
      <SelectFormField
        name={'description'}
        label={'BANK'}
        value={cashInCashOutMethod?.description}
        selectOptions={SpanishBanks}
      />
    </FormGridContainer>
  );
}
